import React from "react";
import { Button } from "antd";
import { ModalComponent } from "@comps/components";

const SingleRosterModal = ({
  title,
  formName,
  saving,
  disabled,
  onCancel,
  children,
}) => (
  <ModalComponent
    width={ 720 }
    top={ 20 }
    maskClosable={ false }
    className="create-roster-modal single-roster-modal"
    rootClassName="create-roster-modal-root single-roster-modal-root"
    bodyStyle={ { padding: 0 } }
    mainTitle={ (
      <div className="create-roster-modal-title">
        <span>{ title }</span>
      </div>
    ) }
    visible={ true }
    footer={ '' }
    onCancel={ onCancel }
    disabled={ disabled }
  >
    <div className="create-roster-shell single-roster-shell">
      <div className="create-roster-content single-roster-content">
        { children }
      </div>
    </div>

    <div className="create-roster-footer">
      <Button className="button-back" onClick={ onCancel }>
        <span style={ { color: "#4079FC" } }>Close</span>
      </Button>
      { !disabled ? (
        <Button className="button-next" type="primary" htmlType="submit" form={ formName } loading={ saving }>
          Save
        </Button>
      ) : null }
    </div>
  </ModalComponent>
);

export default SingleRosterModal;
